var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVodafoneLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8545_22907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6393 1.50819C17.662 -0.483175 23.5127 -0.345429 28.4015 1.96748C27.0085 1.75696 25.5915 1.91567 24.2125 2.14758C20.4675 2.85112 16.9085 4.604 14.1265 7.20803C11.4591 9.81617 9.58992 13.2767 9.06206 16.979C8.71277 19.6024 9.03643 22.354 10.2199 24.7417C11.4393 27.2471 13.5859 29.3018 16.1731 30.3622C18.6661 31.4116 21.5579 31.4 24.0831 30.4634C27.872 29.0801 30.5944 25.3454 30.9056 21.3552C31.1016 18.7401 30.4621 15.958 28.6958 13.9523C27.0097 11.9889 24.5436 10.9074 22.0759 10.2919C21.9436 7.87085 23.0903 5.479 24.9086 3.90457C25.9185 2.99873 27.1718 2.42143 28.4676 2.05178L28.566 2.01806C32.2759 3.7878 35.4282 6.70638 37.4367 10.2894C39.1575 13.34 40.055 16.8552 39.9661 20.3569C39.9491 24.8848 38.2477 29.368 35.3311 32.8301C32.5731 36.132 28.7157 38.507 24.5114 39.458C20.2959 40.4255 15.7606 40.0082 11.8154 38.2261C7.95508 36.5111 4.68458 33.5296 2.60414 29.8622C0.873399 26.8145 -0.042193 23.3005 0.0338652 19.7948C0.0421325 15.4268 1.60133 11.0925 4.32371 7.67678C6.4984 4.94939 9.38324 2.78081 12.6393 1.50819Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2125 2.14755C25.5915 1.91564 27.0085 1.75692 28.4015 1.96745L28.6016 2.00117L28.4677 2.05174C27.1718 2.4214 25.9185 2.9987 24.9086 3.90454C23.0903 5.47896 21.9436 7.87082 22.0759 10.2919C24.5436 10.9074 27.0097 11.9888 28.6958 13.9522C30.4621 15.958 31.1016 18.7401 30.9057 21.3552C30.5944 25.3453 27.872 29.0801 24.0832 30.4633C21.5579 31.4 18.6661 31.4115 16.1731 30.3622C13.5859 29.3017 11.4393 27.2471 10.2199 24.7417C9.03644 22.354 8.71278 19.6023 9.06207 16.979C9.58993 13.2767 11.4591 9.81613 14.1266 7.20799C16.9085 4.60396 20.4675 2.85108 24.2125 2.14755Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8545_22907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodafoneLogoIcon);
export default __webpack_public_path__ + "static/media/vodafone-logo-icon.c740f78415312b851ff69e87e984c887.svg";
export { ForwardRef as ReactComponent };